import { render, staticRenderFns } from "./loginIndex.vue?vue&type=template&id=22f9f1f7&scoped=true"
import script from "./loginIndex.vue?vue&type=script&lang=js"
export * from "./loginIndex.vue?vue&type=script&lang=js"
import style0 from "./loginIndex.vue?vue&type=style&index=0&id=22f9f1f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9f1f7",
  null
  
)

export default component.exports